import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  { t: "Choose your services", d: "Pick one or several cleanings — we tailor the visit to your space." },
  { t: "Pick a date & slot", d: "Choose a day and time that works. Need a price first? Request a free quote." },
  { t: "We clean, in detail", d: "Our team arrives on time with supplies and works room by room." },
  { t: "Final walkthrough", d: "Every visit ends with a check, so nothing gets missed." },
];

export const Process = () => (
  <section id="process" className="relative border-t border-white/5 bg-[#0d1220]" data-testid="process-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-36">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>How it works</Eyebrow>
            <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Four steps to a <span className="text-outline">sparkling</span> space.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="notch-clip mt-10 hidden overflow-hidden lg:block">
            <img src="/img/spray.jpg" alt="Gloved hand with spray bottle" className="h-64 w-full object-cover" loading="lazy" />
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7">
        {STEPS.map((s, i) => (
          <Reveal key={s.t} delay={i * 0.05}>
            <li className="group flex gap-6 border-b border-white/10 py-9 sm:gap-10" data-testid={`process-step-${i + 1}`}>
              <span className="font-display text-5xl font-extrabold text-white/15 transition-colors duration-500 group-hover:text-amber-300 sm:text-7xl">0{i + 1}</span>
              <div className="pt-2">
                <h3 className="font-display text-2xl font-bold text-white sm:text-3xl">{s.t}</h3>
                <p className="mt-3 max-w-md text-base text-slate-300">{s.d}</p>
                <motion.span initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }} transition={{ duration: 1.2, delay: 0.2 }} className="mt-6 block h-px w-24 origin-left bg-amber-300" />
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
